import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import { JobPostingsService } from '../services/openapi/api/jobPostings.service';
import { JobPostingResponse } from '../services/openapi/model/jobPostingResponse';

export const postingResolver: ResolveFn<JobPostingResponse | RedirectCommand> = (route: ActivatedRouteSnapshot) => {
  const jobPostingsService = inject(JobPostingsService);
  const router = inject(Router);
  const id = route.paramMap.get('id');

  if (!id) {
    return new RedirectCommand(router.parseUrl('/not-found'));
  }

  return jobPostingsService.getJobPostingByNumber(id).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 404) {
        return of(new RedirectCommand(router.parseUrl('/not-found')));
      }

      return of(new RedirectCommand(router.parseUrl('/forbidden')));
    })
  );
};
